import { logger } from '@automata/utils';

/**
 * Generic function to reorder items in an array
 * @param items - Array of items to reorder
 * @param oldIndex - Current index of the item
 * @param targetIndex - Target index to move the item to
 * @returns Reordered array or null if operation failed
 */
export function getReorderedItems<T>(
  items: T[],
  oldIndex: number,
  targetIndex: number
): T[] | null {
  const item = items[oldIndex];
  if (!item) {
    logger.info(`Failed to get item at index: ${oldIndex}`);
    return null;
  }

  const newItems = [...items];
  newItems.splice(oldIndex, 1);
  newItems.splice(targetIndex, 0, item);

  return newItems;
}

/**
 * Utility function specifically for use with DataGrid reordering callbacks
 */
export function createReorderHandler<T>(
  items: T[],
  onReorder: (reorderedItems: T[]) => void
) {
  return (oldIndex: number, targetIndex: number) => {
    const reordered = getReorderedItems(items, oldIndex, targetIndex);
    if (reordered) {
      onReorder(reordered);
    }
  };
}
